import React, { useState } from "react";

import "./../styling/Calculator.css"

const MidpointCalculator = () => {
  const [point1, setPoint1] = useState("");
  const [point2, setPoint2] = useState("");
  const [midpoint, setMidpoint] = useState(null);

  const calculateMidpoint = () => {
    const [lat1, lon1] = cleanNumberInput(point1).split(/[, ]+/).map(Number);
    const [lat2, lon2] = cleanNumberInput(point2).split(/[, ]+/).map(Number);

    if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
      alert("Invalid coordinates!");
      return;
    }

    const midLat = (lat1 + lat2) / 2;
    const midLon = (lon1 + lon2) / 2;

    setMidpoint(`${midLat.toFixed(6)}, ${midLon.toFixed(6)}`);
  };

  const cleanNumberInput= (input) => {
    return input.replace(/[^0-9.,]/g, '');
}

  return (
    <div className="calculator-card">
      <h2>Midpoint Calculator</h2>
      <input type="text" placeholder="Enter Point 1 (lat, long)" value={point1} onChange={(e) => setPoint1(e.target.value)} />
      <input type="text" placeholder="Enter Point 2 (lat, long)" value={point2} onChange={(e) => setPoint2(e.target.value)} />
      <button onClick={calculateMidpoint}>Calculate Midpoint</button>
      {midpoint && <p>Midpoint: {midpoint}</p>}

      <div className="info-section">
  <h3>What is a Midpoint?</h3>
  <p>
    A midpoint is the geographic center between two locations. This is useful for **meeting points, 
    route planning, and navigation**.
  </p>
  <a href="https://en.wikipedia.org/wiki/Geographical_midpoint" target="_blank" rel="noopener noreferrer">
    Learn more on Wikipedia
  </a>
</div>
    </div>
  );
};

export default MidpointCalculator;